import moment from "moment"
import { getDisplayStatus } from "./mustReadStatus"

export const PAGE_TITLE = "Onboarding Resources"
export const PAGE_INTRO =
  "Review each resource below before installing or using your ColdBlock digestion system. You can review them in any order. Confirm your review of each resource to update your progress."
export const ALL_DONE =
  "You’re up to date. You have confirmed your review of all current onboarding resources."
export const EMPTY_STATE = "There are no onboarding resources for your account right now."
export const BANNER_HEADING = "Onboarding Resources"
export const BANNER_CTA = "Review Remaining Resources"
export const BANNER_DETAIL =
  "Complete these simple steps before you begin working with your ColdBlock digestion system."
export const UPDATED_NOTICE_BODY =
  "A revised version is available. Please review the update and confirm your review."
export const CONFIRM_BUTTON = "Confirm review"

export function resourceNoun(n) {
  return n === 1 ? "resource" : "resources"
}

export function progressText(reviewed, total) {
  const remaining = total - reviewed
  return `Your progress: ${reviewed} of ${total} ${resourceNoun(total)} reviewed, ${remaining} ${resourceNoun(remaining)} remaining`
}

export function bannerCount(reviewed, total) {
  return `${reviewed} of ${total} ${resourceNoun(total)} reviewed.`
}

export function actionLabel(item) {
  const display = getDisplayStatus(item)
  if (display === "reviewed") return "View again"
  if (display === "updated") return "Review update"
  if (display === "in_progress") {
    return item.contentType === "video" ? "Continue watching" : "Continue review"
  }
  return item.contentType === "video" ? "Watch video" : "Review document"
}

export function confirmStatement(contentType) {
  return contentType === "video"
    ? "I confirm that I have watched this video in full."
    : "I confirm that I have reviewed this document in full."
}

export function updatedNoticeHeading(title) {
  return `Updated resource: ${title}`
}

export function versionLabel(versionNumber, publishedAt) {
  if (versionNumber == null) return null
  if (!publishedAt) return `Version ${versionNumber}`
  const date = moment(publishedAt).format("MMM D, YYYY")
  const verb = versionNumber === 1 ? "Published" : "Revised"
  return `Version ${versionNumber} · ${verb} ${date}`
}
